import React from "react";
import { Box, Button, SpaceBetween } from "@cloudscape-design/components";
import { RecentSearchEntry } from "../../utils/RecentSearches";
import { LABELS } from "../../constants";

interface RecentSearchesRowProps {
  entries: RecentSearchEntry[];
  onSelect: (entry: RecentSearchEntry) => void;
  onClear: () => void;
}

export const RecentSearchesRow: React.FC<RecentSearchesRowProps> = ({ entries, onSelect, onClear }) => {
  if (entries.length === 0) {
    return null;
  }

  return (
    <SpaceBetween direction="horizontal" size="xs" alignItems="center">
      <Box variant="awsui-key-label">{LABELS.RECENT_SEARCHES}</Box>
      {entries.map((entry) => (
        <Button key={`${entry.realm}-${entry.customerId}`} variant="inline-link" onClick={() => onSelect(entry)}>
          {entry.customerId} ({entry.realm})
        </Button>
      ))}
      <Button variant="inline-link" onClick={onClear}>
        {LABELS.CLEAR}
      </Button>
    </SpaceBetween>
  );
};
